import { data } from '../../svg/CollapseContent/data';
import { makeIcon } from '../makeIcon';

export const CollapseContent = makeIcon(data, 'collapse_content', 'CollapseContent');

export default CollapseContent;
